import {useSearchParams} from "react-router-dom";
import Page from "../Components/Page";
import {mapRoutesSvToEn} from "../Utils/routes";

function TraitsPage() {
    const [searchParams] = useSearchParams();
    const endpoint = `/pages/traits?${mapRoutesSvToEn(searchParams.toString())}`;

    return <Page endpoint={endpoint} showBackButton={true} />
}

export default TraitsPage;